import { AxiosResponse } from 'axios'
import { API } from '../config'
import { LotDto } from 'src/dto/lot.dto'

const BASE_URL = '/entity/Lote'

export class LotService {
  public async getLotListByFarmId(farmId: string): Promise<AxiosResponse<LotDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}`)
  }

  public async updateLote(farmId: string, updateLotDto: any): Promise<AxiosResponse<LotDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, updateLotDto)
  }
}
